import React from 'react';
import { useInView } from 'react-intersection-observer';

import './style.scss';
import useIsComDomain from '@src/hooks/useIsComDomain';

import DesktopNewFlashSale from '@src/componentsNew/ProductList/NewFlashSale/DesktopNewFlashSale';
import DesktopEditorsPick from '@src/componentsNew/ProductList/EditorsPick/DesktopEditorsPick';
import DesktopNewLaunchBrands from '@src/componentsNew/BrandList/DesktopNewLaunchBrands';
import DesktopNewProducts from '@src/componentsNew/ProductList/NewProducts/DesktopNewProducts';
import DesktopMainNewMGS from '@src/componentsNew/ProductList/MainNewMGS/DesktopMainNewMGS';
import DesktopHomeOffers from '@src/componentsNew/Offers/DesktopHomeOffers';
import DesktopComMainCollection from '@src/componentsNew/ProductList/ComMainCollection/DesktopComMainCollection';

function DesktopHome() {
  const isComDomain = useIsComDomain();

  const { ref: editorsPickRef, inView: editorsPickInView } = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  const { ref: newLaunchBrandsRef, inView: newLaunchBrandsInView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const { ref: newProductsRef, inView: newProductsInView } = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });

  return (
    <section className="desktop-home-section">
      {isComDomain ? (
        <>
          <DesktopNewProducts />

          {process.env.ENVIRONMENT === 'production' && process.env.COM_MAIN_MOST_POPULAR_COLLECTION_ID && (
            <DesktopComMainCollection />
          )}

          <DesktopHomeOffers />
        </>
      ) : (
        <>
          <DesktopNewFlashSale />

          <DesktopEditorsPick ref={editorsPickRef} />

          {editorsPickInView && (
            <>
              {process.env.ENVIRONMENT === 'production' && process.env.NEW_ARRIVAL_MGS_COLLECTION_ID && (
                <DesktopMainNewMGS />
              )}

              <DesktopNewLaunchBrands ref={newLaunchBrandsRef} />
            </>
          )}

          {newLaunchBrandsInView && <DesktopNewProducts ref={newProductsRef} />}

          {newProductsInView && <DesktopHomeOffers />}
        </>
      )}
    </section>
  );
}

export default DesktopHome;
